import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { first, firstValueFrom } from 'rxjs';
import { LibraryCDMS } from 'src/app/types/General/Library.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';

export const libraryGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserDataService);
  const masterService = inject(LibraryMasterService);

  const routeLibraries = Array.isArray(route.data?.['library'])
    ? (route.data?.['library'] as LibraryCDMS[])
    : [];

  const slug = String(route.paramMap.get('libSlug') || '').trim().toUpperCase();
  const librariesToValidate: LibraryCDMS[] = routeLibraries.length > 0
    ? routeLibraries
    : (slug ? [slug] : []);

  const normalizeLibraryAliases = (value: string): string[] => {
    const normalized = String(value || '').trim().toUpperCase();
    if (normalized === 'FIN' || normalized === 'PROCESSES') {
      return ['FIN', 'PROCESSES'];
    }

    return [normalized];
  };

  return (async () => {
    await firstValueFrom(userService.GetDataUser.pipe(first((value) => value.ID !== 0)));

    if (librariesToValidate.length === 0 || userService.UserLibraryIn(librariesToValidate)) {
      return true;
    }

    // Fallback: validar acceso dinámico consultando librerías activas del usuario,
    // que incluye accesos otorgados por pertenencia a grupos segmentados.
    try {
      const res: Response_FIN = await firstValueFrom(masterService.Get_My_Active_Libraries());
      if (res.success) {
        const dynamicSlugs = (res.operation || []).map((lib: any) => String(lib?.Slug || '').trim().toUpperCase());
        const hasDynamicAccess = librariesToValidate.some((library) =>
          normalizeLibraryAliases(String(library || '')).some((candidate) => dynamicSlugs.includes(candidate))
        );

        if (hasDynamicAccess) {
          return true;
        }
      }
    } catch (error) {
      // Si falla la consulta fallback, mantenemos el comportamiento de seguridad por defecto.
    }

    router.navigate(['/NotRelatLibrary']);
    return false;
  })();
};
